import React, { useEffect } from "react";
import Page from "../../common/layout/Page";
import useEffacementDonnees from "./useEffacementDonnees";
import ApercuEffacement from "./ApercuEffacement";
import SuiviEffacement, { TITRE_SUIVI } from "./SuiviEffacement";
import PanneauEffacement from "./PanneauEffacement";
import RegistreEffacements from "./RegistreEffacements";
import TitreEtape from "./TitreEtape";
import { doitSuivre } from "./effacementDonnees";
import "./effacementDonnees.scss";

const INTERVALLE_SUIVI_MS = 2000;

const EffacementDonneesPage = () => {
  const {
    email,
    setEmail,
    apercu,
    demande,
    panneauOuvert,
    registre,
    registreCharge,
    rechercheEnCours,
    envoiEnCours,
    actions,
  } = useEffacementDonnees();

  const { chargerRegistre, actualiser } = actions;

  useEffect(() => {
    chargerRegistre(1);
  }, [chargerRegistre]);

  useEffect(() => {
    if (!demande || !doitSuivre(demande.statut.id)) return undefined;
    const minuteur = setTimeout(() => actualiser(demande.id), INTERVALLE_SUIVI_MS);
    return () => clearTimeout(minuteur);
  }, [demande, actualiser]);

  const rechercher = (e) => {
    e.preventDefault();
    actions.apercevoir();
  };

  return (
    <Page
      title="Effacement de données personnelles"
      subTitle="Droit à l'effacement d'un prospect sans contrat"
      titleMargin="mb-3"
    >
      <div className="effacement">
        <p className="effacement__intro">
          <i className="fa fa-info-circle" aria-hidden="true" />
          <span>
            L'effacement est définitif : il porte sur toutes les données de la personne, chez Perceval et chez ses
            partenaires. Il est refusé si un contrat existe, même résilié. Le registre en garde une trace, sans
            aucune donnée personnelle.
          </span>
        </p>

        <section className="effacement__carte" aria-labelledby="titre-recherche">
          <header className="effacement__entete">
            <TitreEtape numero={1} id="titre-recherche">
              Rechercher l'adresse du demandeur
            </TitreEtape>
          </header>
          <form onSubmit={rechercher}>
            <label className="effacement__libelle" htmlFor="email-effacement">
              Adresse email indiquée dans la demande
            </label>
            <div className="effacement__formulaire">
              <input
                id="email-effacement"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="prenom.nom@exemple.fr"
                autoComplete="off"
                required
              />
              <button type="submit" className="btn btn-primary" disabled={rechercheEnCours || !email.trim()}>
                <i className={`fa ${rechercheEnCours ? "fa-spinner fa-spin" : "fa-search"} mr-2`} aria-hidden="true" />
                Voir ce qui sera effacé
              </button>
            </div>
          </form>
        </section>

        {apercu && <ApercuEffacement apercu={apercu} envoiEnCours={envoiEnCours} onEffacer={actions.effacer} />}

        <RegistreEffacements
          registre={registre}
          charge={registreCharge}
          demandeOuverteId={panneauOuvert ? demande?.id : null}
          onConsulter={actions.consulter}
          onChangerPage={actions.chargerRegistre}
        />

        {panneauOuvert && demande && (
          <PanneauEffacement
            titreId={TITRE_SUIVI}
            onFermer={actions.fermerPanneau}
            retourFocus={() =>
              document.querySelector(`[data-demande="${demande.id}"]`) || document.getElementById("email-effacement")
            }
          >
            <SuiviEffacement
              demande={demande}
              onRelancer={actions.relancer}
              onAbandonner={actions.abandonner}
              onFermer={actions.fermerPanneau}
            />
          </PanneauEffacement>
        )}
      </div>
    </Page>
  );
};

export default EffacementDonneesPage;
